<script>
  import calculate from '@mixins/calculate'
  import modal from '@mixins/modal'
  import VPanel from '@components/Panel'
  import FormTransformer from '@transformers/FormTransformer'
  import { mapGetters } from 'vuex'

  export default {
    name: 'page-area',
    template: '#template_modulkonfigurator_area',
    components: { VPanel },
    mixins: [calculate, modal],
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters(['form', 'courses', 'selected', 'selectedCourse', 'modules']),
        modulconfiguratorCssClass () {
            if (!this.selectedCourse) {
                return ''
            }
            return 'course-' + this.form.uid
        },
      moduesNeeded () {
        let min = 0
        if (!this.selectedCourse) return 0
        this.selectedCourse.areas.forEach((area) => {
          if (area.hasOwnProperty('min')) {
            min = min + parseInt(area.min)
          }
        })
        return min
      },
      selectedCount () {
        if (!this.selected) return 0
        return this.selected.length
      }
    },
    methods: {
      // loadFormByCourse (id) {
      loadFormByCourse () {
        const self = this
        let course = self.$store.getters.getCourseById('c1')
        self.$store.dispatch('setSelectedCourse', course)
        let form = FormTransformer.fetch(course)
        self.$store.dispatch('setForm', form)
        self.calculateForm(form)
      }
    },
    mounted () {
      this.loadFormByCourse('c1')
    }
  }
</script>
